
import type { PropType } from 'vue';

import { defineComponent } from 'vue';

import type { MenuItem } from '@/types';

export default defineComponent({
  props: {
    menuItems: {
      type: Array as PropType<MenuItem[]>,
      required: true,
    },
  },
});
